module.exports = __webpack_public_path__ + "static/media/rocket.d2f3bf41.png";